import type { SelectedPlace } from './placesSearch.types';
import type { CboResourceFormValues } from '../forms/cboResourceForm/cboResourceForm.schema';
import { deriveCategoryFromPlaceTypes } from './deriveCategoryFromPlaceTypes.util';
import { parseFormattedAddress } from './parseFormattedAddress.util';

/**
 * Maps a Google Places selection into partial CBO form values.
 *
 * @param place - Selected place from autocomplete.
 * @returns Partial form values for autofill.
 */
export function mapSelectedPlaceToFormValues(
  place: SelectedPlace
): Partial<CboResourceFormValues> {
  const parsed = parseFormattedAddress(place.formattedAddress);

  return {
    name: place.name,
    address: place.formattedAddress,
    streetAddress: parsed.streetAddress,
    city: parsed.city,
    state: parsed.state,
    zipcode: parsed.zipcode,
    googlePlaceId: place.placeId,
    placeTypes: place.types,
    categoryLabel: deriveCategoryFromPlaceTypes(place.types),
    phoneNumber: place.phoneNumber,
    websiteUrl: place.websiteUrl,
  };
}
